import React from 'react';
import { List, Typography } from 'antd';

interface Props {
  rates: string[];
  onSelect(symbol: string): void;
}
const { Text } = Typography;

const RateList: React.FC<Props> = ({ rates, onSelect }) => {
  if (!Array.isArray(rates)) return null;
  return (
    <List
      bordered
      dataSource={rates}
      renderItem={item => (
        <List.Item
          onClick={() => onSelect(item)}
          style={{ cursor: 'pointer' }}
        >
          <Text>{item}</Text>
        </List.Item>
      )}
    />
  );
};

export default RateList;
